import { Grid, Stack } from "@mui/material";
import React, { useEffect } from "react";
import { StyledTextField } from "./styled-components/AddressFields";
import { Label } from "./SelectAccountType";
import { useUserSlice } from "src/store/features/user.slice";
import { Field, useFormikContext } from "formik";
import RekycAddressLookUp1, { StyledEndAdorment } from "./RekycAddressLookup1";
import RekycAddressLookUp2 from "./RekycAddressLookup2";
import { useAppDispatch } from "src/store/store";
import { FormValues } from "./utils/formSchema";
import { setRekycEntityId } from "src/store/features/onboarding.slice";
import { FileUpload } from "./FileUploadField";
import { trackEvent } from "src/Amplitude";

export default function RekycEntity() {
  const {
    details: { name: entityName },
  } = useUserSlice();
  const dispatch = useAppDispatch();
  const {
    values: { reKycEntityId },
    errors: { reKycEntityId: reKycEntityIdErrorMessage },
  } = useFormikContext<FormValues>();

  useEffect(() => {
    dispatch(setRekycEntityId(reKycEntityId));
  }, [reKycEntityId]);

  useEffect(() => {
    trackEvent("Visit_Page", { page: "Re-KYC Application About Your Entity" }, "Re-KYC");
  }, []);

  return (
    <Grid container spacing={1} padding={"20px"}>
      <Grid item xs={12} md={12} lg={6}>
        <Stack spacing={1}>
          <Label text="Account Name" />
          <StyledTextField
            InputProps={{
              readOnly: true,
              endAdornment: <StyledEndAdorment selected={!!entityName} />,
            }}
            disabled={true}
            selected={true}
            defaultValue={entityName}
          />
        </Stack>
      </Grid>
      <Grid item xs={12} md={12} lg={6}>
        <Stack spacing={1}>
          <Label text="Entity Identification Number e.g. EIN, ABN/ACN, etc." />
          <Field
            name="reKycEntityId"
            as={StyledTextField}
            selected={!!reKycEntityId}
            error={!!reKycEntityIdErrorMessage}
            helperText={reKycEntityIdErrorMessage}
            InputProps={{
              endAdornment: <StyledEndAdorment selected={!!reKycEntityId} />,
            }}
          />
        </Stack>
      </Grid>
      <Grid item xs={12}>
        <Stack mb={1} pt={1}>
          <Label text="Registered Office Address" />
        </Stack>
        <Stack>
          <RekycAddressLookUp1 />
        </Stack>
      </Grid>
      <Grid item xs={12}>
        <RekycAddressLookUp2 />
      </Grid>
      <Grid item xs={12} mt={2}>
        <Label text="Upload Documents" />
      </Grid>
      <FileUpload documentType={"Entity"} />
    </Grid>
  );
}
